import vector1 from "../assets/vector1.png";
import vector2 from "../assets/vector2.png";
import vector3 from "../assets/vector3.png";
import vector4 from "../assets/vector4.png";
import vector5 from "../assets/vector5.png";
import vector6 from "../assets/vector6.png";
import vector7 from "../assets/vector7.png";
import vector8 from "../assets/vector8.png";
import vector9 from "../assets/vector9.png";
import vector10 from "../assets/vector10.png";
import vector11 from "../assets/vector11.png";
import View from "../assets/View.png";
import Edit from "../assets/Edit.png";
import Delete from "../assets/Delete.png";
import Dashboard from "../assets/Dashboard.svg";
import Developer from "../assets/Developer.svg";
import Lead from "../assets/Lead.svg";
import Manager from "../assets/Manager.svg"
import vp from "../assets/VP.svg";
import Property from "../assets/Property.svg";
import Executive from "../assets/Executive.svg";
import Broadcast from "../assets/Broadcast.svg";
import Account from "../assets/Account.svg";



export const SidebarData = [
  {
    icon1: Dashboard,
    icon2: vector1,
    name: "Dashboard",
  },
  {
    icon1: Developer,
    icon2: vector2,
    name: "Developer Management",
  },
  {
    icon1: Property,
    icon2: vector4,
    name: "Property Management",
  },
  {
    icon1: Executive,
    icon2: vector3,
    name: "Executive Management",
  },
  {
    icon1: Manager,
    icon2: vector5,
    name: "Manager Management",
  },
  {
    icon1: vp,
    icon2: vector6,
    name: "VP Management",
  },
  {
    icon1: Lead,
    icon2: vector7,
    name: "Leads Management",
  },
  {
    icon1: vector8,
    icon2: vector8,
    name: "Report Management",
  },
  {
    icon1: Broadcast,
    icon2: vector9,
    name: "Token Management",
  },
  {
    icon1: vp,
    icon2: vector6,
    name: "Url Management",
  },
  {
    icon1: Broadcast,
    icon2: vector9,
    name: "Broadcast Management",
  },
  {
    icon1: vector8,
    icon2: vector8,
    name: "Content Management",
  },
  {
    icon1: Account,
    icon2: vector10,
    name: "My Account",
  },
  {
    icon1: vector11,
    icon2: vector11,
    name: "Logout",
  },
];

export const statesAndCities = {
  "Andhra Pradesh": [
    "Visakhapatnam",
    "Vijayawada",
    "Guntur",
    "Nellore",
    "Tirupati",
    "Kurnool",
    "Rajahmundry",
    "Kadapa",
    "Anantapur",
    "Chittoor",
  ],
  "Arunachal Pradesh": ["Itanagar", "Tawang", "Ziro", "Pasighat", "Bomdila"],
  Assam: [
    "Guwahati",
    "Silchar",
    "Dibrugarh",
    "Jorhat",
    "Tinsukia",
    "Nagaon",
    "Tezpur",
    "Sivasagar",
  ],
  Bihar: [
    "Patna",
    "Gaya",
    "Bhagalpur",
    "Muzaffarpur",
    "Darbhanga",
    "Purnia",
    "Chapra",
    "Hajipur",
    "Bihar Sharif",
    "Arrah",
  ],
  Chhattisgarh: [
    "Raipur",
    "Bilaspur",
    "Durg",
    "Korba",
    "Bhilai",
    "Rajnandgaon",
    "Jagdalpur",
    "Ambikapur",
    "Raigarh",
  ],
  Goa: ["Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda"],
  Gujarat: [
    "Ahmedabad",
    "Surat",
    "Vadodara",
    "Rajkot",
    "Bhavnagar",
    "Jamnagar",
    "Junagadh",
    "Gandhinagar",
    "Anand",
    "Navsari",
  ],
  Haryana: [
    "Gurugram",
    "Faridabad",
    "Panipat",
    "Ambala",
    "Karnal",
    "Hisar",
    "Sonipat",
    "Yamunanagar",
    "Rohtak",
    "Bhiwani",
  ],
  "Himachal Pradesh": [
    "Shimla",
    "Manali",
    "Dharamshala",
    "Solan",
    "Mandi",
    "Kullu",
    "Palampur",
    "Chamba",
    "Hamirpur",
  ],
  Jharkhand: [
    "Ranchi",
    "Jamshedpur",
    "Dhanbad",
    "Bokaro",
    "Deoghar",
    "Hazaribagh",
    "Ramgarh",
    "Giridih",
    "Phusro",
  ],
  Karnataka: [
    "Bengaluru",
    "Mysuru",
    "Mangaluru",
    "Hubballi",
    "Belagavi",
    "Davanagere",
    "Ballari",
    "Tumakuru",
    "Shivamogga",
    "Udupi",
  ],
  Kerala: [
    "Thiruvananthapuram",
    "Kochi",
    "Kozhikode",
    "Thrissur",
    "Kannur",
    "Kollam",
    "Alappuzha",
    "Palakkad",
    "Malappuram",
  ],
  "Madhya Pradesh": [
    "Bhopal",
    "Indore",
    "Gwalior",
    "Jabalpur",
    "Ujjain",
    "Sagar",
    "Satna",
    "Rewa",
    "Ratlam",
    "Shivpuri",
  ],
  Maharashtra: [
    "Mumbai",
    "Pune",
    "Nagpur",
    "Nashik",
    "Thane",
    "Aurangabad",
    "Solapur",
    "Kolhapur",
    "Amravati",
    "Sangli",
  ],
  Manipur: ["Imphal", "Churachandpur", "Thoubal", "Bishnupur", "Ukhrul"],
  Meghalaya: ["Shillong", "Tura", "Cherrapunji", "Jowai", "Nongpoh"],
  Mizoram: ["Aizawl", "Lunglei", "Champhai", "Serchhip", "Kolasib"],
  Nagaland: ["Kohima", "Dimapur", "Mokokchung", "Tuensang", "Mon"],
  Odisha: [
    "Bhubaneswar",
    "Cuttack",
    "Rourkela",
    "Sambalpur",
    "Berhampur",
    "Puri",
    "Balasore",
    "Bhadrak",
    "Baripada",
    "Jeypore",
  ],
  Punjab: [
    "Chandigarh",
    "Amritsar",
    "Ludhiana",
    "Jalandhar",
    "Patiala",
    "Bathinda",
    "Mohali",
    "Hoshiarpur",
    "Pathankot",
    "Moga",
  ],
  Rajasthan: [
    "Jaipur",
    "Udaipur",
    "Jodhpur",
    "Kota",
    "Ajmer",
    "Bikaner",
    "Alwar",
    "Bharatpur",
    "Sikar",
    "Pali",
  ],
  Sikkim: ["Gangtok", "Namchi", "Pelling", "Gyalshing", "Mangan"],
  "Tamil Nadu": [
    "Chennai",
    "Coimbatore",
    "Madurai",
    "Tiruchirappalli",
    "Salem",
    "Erode",
    "Tirunelveli",
    "Vellore",
    "Thoothukudi",
  ],
  Telangana: [
    "Hyderabad",
    "Warangal",
    "Nizamabad",
    "Khammam",
    "Karimnagar",
    "Mahbubnagar",
    "Ramagundam",
    "Adilabad",
  ],
  Tripura: ["Agartala", "Udaipur", "Dharmanagar", "Kailashahar", "Belonia"],
  Uttarakhand: [
    "Dehradun",
    "Haridwar",
    "Nainital",
    "Rishikesh",
    "Haldwani",
    "Almora",
    "Pithoragarh",
    "Rudrapur",
  ],
  "Uttar Pradesh": [
    "Lucknow",
    "Kanpur",
    "Varanasi",
    "Agra",
    "Meerut",
    "Allahabad (Prayagraj)",
    "Gorakhpur",
    "Bareilly",
    "Aligarh",
    "Moradabad",
  ],
  "West Bengal": [
    "Kolkata",
    "Darjeeling",
    "Asansol",
    "Siliguri",
    "Durgapur",
    "Howrah",
    "Kharagpur",
    "Malda",
    "Jalpaiguri",
  ],
  "Andaman and Nicobar Islands": [
    "Port Blair",
    "Havelock Island",
    "Neil Island",
    "Rangat",
    "Diglipur",
  ],
};
;

export const leadOptions = [
  { label: "Resent Request", value: "RESENTREQUEST" },
  { label: "Generated Lead", value: "GENERATEDLEAD" },
  { label: "Booked Visit", value: "BOOKEDVISIT" },
];

export const callOptions = [
  { label: "Set Reminder", value: "SETREMINDER" },
  { label: "Busy", value: "BUSY" },
  { label: "Not Interested", value: "NOTINTERESTED" },
  { label: "Not Connected", value: "NOTCONNECTED" },
  { label: "Wrong Number", value: "WRONGNUMBER" },
  { label: "Booked Visit", value: "BOOKEDVISIT" },
  { label: "Mark as Lead", value: "MARKASLEAD" },
];

export const locations = [
  "All Locations",
  "Ahmedabad",
  "Bangalore",
  "Bhopal",
  "Chandigarh",
  "Chennai",
  "Coimbatore",
  "Delhi",
  "Goa",
  "Gurgaon",
  "Hyderabad",
  "Indore",
  "Jaipur",
  "Kochi",
  "Kolkata",
  "Lucknow",
  "Madurai",
  "Mumbai",
  "Mysore",
  "Nagpur",
  "Noida",
  "Patna",
  "Pune",
  "Surat",
  "Vadodara",
  "Varanasi",
  "Visakhapatnam",
  "Agra",
  "Ambala",
  "Dehradun",
  "Faridabad",
  "Gwalior",
  "Kanpur",
  "Kochi",
  "Ludhiana",
  "Meerut",
  "Navi Mumbai",
  "Ranchi",
  "Rajkot",
  "Shimla",
  "Sonipat",
  "Trivandrum",
  "Udaipur",
  "Vijayawada",
];


